// extracted by mini-css-extract-plugin
export default {"statusBar":"StatusBar_statusBar__Qqewv"};